
// Helper function to calculate time on platform
const calculateTimeOnPlatform = (startDate) => {
  if (!startDate) return '0 d\u00edas';
  
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now - start);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 30) {
    return `${diffDays} d\u00edas`;
  } else if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return `${months} ${months === 1 ? 'mes' : 'meses'}`;
  } else {
    const years = Math.floor(diffDays / 365);
    const remainingMonths = Math.floor((diffDays % 365) / 30);
    if (remainingMonths === 0) {
      return `${years} ${years === 1 ? 'a\u00f1o' : 'a\u00f1os'}`;
    }
    return `${years}a ${remainingMonths}m`;
  }
};

export { calculateTimeOnPlatform };
